import React from 'react';
import { Award, ShieldCheck, UserCheck, GraduationCap } from 'lucide-react';
import { complianceBadges } from '../../data/mock';

const iconMap = {
  0: Award,
  1: ShieldCheck,
  2: UserCheck,
  3: GraduationCap,
};

const ComplianceStrip = () => {
  return (
    <section className="relative py-16 border-y border-white/10 bg-gradient-to-r from-transparent via-white/[0.02] to-transparent">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {complianceBadges.map((badge, index) => {
            const Icon = iconMap[index];
            return (
              <div
                key={badge.id}
                className="group flex flex-col items-center text-center p-6 transition-all duration-300 hover:bg-white/5"
              >
                <div className="w-14 h-14 flex items-center justify-center mb-4 border border-[#00D4FF]/30 group-hover:border-[#00D4FF] transition-colors duration-300">
                  <Icon className="w-7 h-7 text-[#00D4FF]" strokeWidth={1.5} />
                </div>
                <h3 className="text-white font-semibold mb-2 text-sm lg:text-base">
                  {badge.title}
                </h3>
                <p className="text-gray-500 text-xs lg:text-sm">
                  {badge.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ComplianceStrip;
